<angular2-multiselect name="permissions"
                      required
                      [data]="permissionsList"
                      [(ngModel)]="permissions"
                      (onSelect)="onSelect($event)"
                      (onDeSelect)="onDeSelect($event)"
                      (onSelectAll)="selectAll($event)"
                      (onDeSelectAll)="deSelectAll($event)"
                      [settings]="multiselectSettings">
</angular2-multiselect>




// WEBPACK FOOTER //
// /app/src/app/views/documents/permissions-select/permissions-select.component.html